import { render, staticRenderFns } from "./character.vue?vue&type=template&id=52b4119e&scoped=true"
import script from "./character.vue?vue&type=script&lang=js"
export * from "./character.vue?vue&type=script&lang=js"
import style0 from "./character.vue?vue&type=style&index=0&id=52b4119e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b4119e",
  null
  
)

export default component.exports